import { render, staticRenderFns } from "./CollectionBox.vue?vue&type=template&id=ad656d72&scoped=true"
import script from "./CollectionBox.vue?vue&type=script&lang=js"
export * from "./CollectionBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad656d72",
  null
  
)

export default component.exports